export class CreateDimensionError extends Error {
}
